import React from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLogoutUserMutation, useLogoutAllUsersMutation } from "../../redux/userApi";
import { useTranslation } from "react-i18next";

function LogoutUserModal({ show, onHide, user, logoutAll }) {
  const { t } = useTranslation();
  const [logoutUser, { isLoading: isLoggingOutUser }] = useLogoutUserMutation();
  const [logoutAllUsers, { isLoading: isLoggingOutAll }] = useLogoutAllUsersMutation();

  const isLoading = isLoggingOutUser || isLoggingOutAll;

  const handleConfirm = async () => {
    try {
      let response;
      if (logoutAll) {
        response = await logoutAllUsers();
      } else {
        response = await logoutUser({ userId: user?.id });
      }

      if (response?.data?.status) {
        toast.success(
          response.data.message ||
            (logoutAll
              ? t("logout_all_success") || "All users logged out successfully."
              : t("logout_user_success") || "User logged out successfully.")
        );
        onHide();
      } else {
        toast.error(
          response?.error?.data?.message ||
            response?.data?.message ||
            (logoutAll
              ? t("logout_all_failed") || "Failed to logout all users."
              : t("logout_user_failed") || "Failed to logout user.")
        );
      }
    } catch (err) {
      toast.error(t("something_went_wrong") || "Something went wrong.");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {logoutAll
            ? t("logout_all_users") || "Logout All Users"
            : t("logout_user") || "Logout User"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {logoutAll ? (
          <p>
            {t("logout_all_confirm") ||
              "Are you sure you want to revoke all active JWT tokens for every user in the system? This will log out all users immediately."}
          </p>
        ) : (
          <p>
            {t("logout_user_confirm") ||
              `Are you sure you want to revoke all active JWT tokens for`}{" "}
            <strong>
              {user?.fname} {user?.lname}
            </strong>
            ? {t("logout_user_confirm_suffix") || "This will immediately log out this user across all devices."}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          {t("cancel") || "Cancel"}
        </Button>
        <Button
          variant={logoutAll ? "danger" : "warning"}
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              {t("processing") || "Processing..."}
            </>
          ) : logoutAll ? (
            t("logout_all_users") || "Logout All Users"
          ) : (
            t("logout_user") || "Logout User"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default LogoutUserModal;
